import * as React from 'react';
import PropTypes from 'prop-types';
import {Snackbar} from "material-ui";
import {translate} from "react-i18next";

let snackbarDefaultDuration = 3000;

const objMap = (obj, callback) => {
	const ret = [];
	for(let k in obj) {
		if ( !obj.hasOwnProperty(k)) continue;
		ret.push(callback.call(obj[k], ret.length));
	}
	return ret;
};

export const setSnackbarGroupDelayDuration = (duration) => snackbarDefaultDuration = Math.max(1000, duration);

const SnackbarGroup = ({t, autoHideDuration = snackbarDefaultDuration, translationBase, i18n, value, onRequestClose, ...props}) => {
	const lang = i18n.getResource(i18n.language, 'translations', translationBase);
	if ( !lang ) {
		console.error('lang ist not ready');
		return null;
	}
	return (
		<React.Fragment>
			{
				objMap(lang,
					(translation, snackbar) =>
						<Snackbar key={snackbar} open={value === snackbar} autoHideDuration={autoHideDuration} message={translation || 'OK'} onRequestClose={onRequestClose} {...props}/>
					)
			}
		</React.Fragment>
	);
};


SnackbarGroup.propTypes = {
	autoHideDuration: PropTypes.number,
	value: PropTypes.string,
	translationBase: PropTypes.string.isRequired,
	onRequestClose: PropTypes.func.isRequired,
};
SnackbarGroup.defaultProps = {
	autoHideDuration: snackbarDefaultDuration,
	value: null
};

const Snack = ({message, t, i18n, tReady, onRequestClose, color, ...props}) => (
	<Snackbar open={!!message} message={t([message || 'empty', 'labels.no-translation'], {value: message})} bodyStyle={{background: color || 'black'}} onRequestClose={onRequestClose} {...props}/>
);
Snack.propTypes = {
	autoHideDuration: PropTypes.number,
	message: PropTypes.string,
	onRequestClose: PropTypes.func.isRequired,
	color: PropTypes.string
};
Snack.defaultProps = {
	autoHideDuration: snackbarDefaultDuration
};
export const IthSnackbar = translate()(Snack);
export default translate()(SnackbarGroup);


// WEBPACK FOOTER //
// ./src/misc/SnackbarGroup.js